const UNAVAILABLE_CODES = new Set(['ACCOUNT_ERROR', 'AUTHORIZATION_TOKEN_ERROR']);
/**
 * Public forms currently receive these GraphQL codes when the account is
 * disabled or expired. They must not be treated as a login failure.
 */
export function isPublicAccountUnavailableError(error) {
    var _a;
    if (!((_a = error === null || error === void 0 ? void 0 : error.graphQLErrors) === null || _a === void 0 ? void 0 : _a.length)) {
        return false;
    }
    return error.graphQLErrors.some((graphQLError) => { var _a, _b; return UNAVAILABLE_CODES.has(String((_b = (_a = graphQLError.extensions) === null || _a === void 0 ? void 0 : _a.code) !== null && _b !== void 0 ? _b : '')); });
}
